"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useSDKScript2 = _interopRequireDefault(require("../hooks/useSDKScript"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function SmartPaymentButtons(props) {
  var containerStyle = props.containerStyle,
      containerClassName = props.containerClassName,
      refresh = props.refresh,
      sdkScriptId = props.sdkScriptId,
      loading = props.loading,
      buttonsConfig = _objectWithoutProperties(props, ["containerStyle", "containerClassName", "refresh", "sdkScriptId", "loading"]);

  var _useSDKScript = (0, _useSDKScript2.default)(sdkScriptId),
      isSDKLoaded = _useSDKScript.isSDKLoaded;

  (0, _react.useEffect)(function () {
    if (isSDKLoaded) {
      window.paypal.Buttons(buttonsConfig).render('#SmartPaymentButtons');
    }
  }, [refresh, isSDKLoaded]);

  if (!isSDKLoaded && loading) {
    return loading;
  }

  return _react.default.createElement("div", {
    id: "SmartPaymentButtons",
    key: "SmartPaymentButtons-".concat(JSON.stringify(refresh) || ''),
    style: props.containerStyle,
    className: props.containerClassName
  });
}

SmartPaymentButtons.defaultProps = {
  onCancel: function onCancel() {},
  onError: function onError() {},
  style: {},
  containerStyle: {},
  containerClassName: ''
};

var _default = _react.default.memo(SmartPaymentButtons);

exports.default = _default;